import { Link } from 'react-router-dom';
import { site } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-cream-300 bg-cream-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
        <div className="flex flex-col gap-8 lg:flex-row lg:justify-between">
          <div className="max-w-md">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-xl text-cream-50">
                <i className="ri-fire-fill" />
              </span>
              <span className="font-display text-2xl text-primary-600">{site.brand}</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-ink-600">
              {site.slogan}。{site.desc}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div>
              <h4 className="mb-3 text-sm font-bold text-ink">栏目导航</h4>
              <ul className="space-y-2 text-sm text-ink-600">
                {site.columns.map((c) => (
                  <li key={c.key}>
                    <Link to={`/column/${c.key}`} className="hover:text-primary-600">
                      {c.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="mb-3 text-sm font-bold text-ink">更多</h4>
              <ul className="space-y-2 text-sm text-ink-600">
                <li>
                  <Link to="/about" className="hover:text-primary-600">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="hover:text-primary-600">
                    内容原则
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="hover:text-primary-600">
                    投稿合作
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h4 className="mb-3 text-sm font-bold text-ink">联系我们</h4>
              <ul className="space-y-2 text-sm text-ink-600">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-500" />
                  <a href={`mailto:${site.email}`} className="hover:text-primary-600">
                    {site.email}
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-primary-500" />
                  编辑部随时在线收素材
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-cream-200 pt-6 text-xs text-ink-600 sm:flex-row">
          <p>
            © {year} {site.brand}。站内人物与故事均为虚构示例内容，仅供娱乐阅读。
          </p>
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-primary-500" />
              虚构内容 · 脱敏发布
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}